'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createParam = createParam;
function createParam() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object.keys(obj).map(function (key) {
    var value = obj[key];
    if (value === undefined) {
      return undefined;
    }
    return key + '=' + encodeURIComponent(value);
  }).filter(Boolean).join('&');
}
//# sourceMappingURL=url.js.map



//////////////////
// WEBPACK FOOTER
// ../~/music-shared/dist/src/utils/url.js
// module id = 8
// module chunks = 9 10 11